export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/php-nginx-service-stack-form';
